import React from "react";
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import cover from '../../assets/images/image-childrens-day_1-p-1600.jpeg'
import Art_Competition_img from '../../assets/images/Rectangle-55-1.png';
import Rectangle_84 from '../../assets/images/Rectangle-84.png';
import './gammaddanagitimusrilanka.css';

const GammaddaNagitimuSriLanka = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <div className="background-color">

        <div className="">

          <div
            className="position-relative overflow-hidden w-100"
            style={{ height: '70vh', maxHeight: '600px' }}
          >
            {/* Background image with overlay */}
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                backgroundImage: `url(${cover})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                zIndex: 1
              }}
            >
              <div className="w-100 h-100 bg-black" style={{ opacity: 0.5 }}></div>
            </div>

            {/* Centered content */}
            <div
              className="position-absolute top-50 start-50 translate-middle text-center w-100 px-3"
              style={{
                maxWidth: '960px',
                zIndex: 2,
                transition: 'opacity 1s ease, transform 1s ease',
                transform: visible ? 'translate(-50%, -50%)' : 'translate(-50%, -40%)',
                opacity: visible ? 1 : 0
              }}
            >
              <h1 className="fw-bold text-white mb-4 display-5"
                style={{ textTransform: 'uppercase', fontFamily: 'Yanone Kaffeesatz,sans-serif' }}>Nagitimu
                Sri Lanka </h1>

            </div>
          </div>

        </div>
      </div>

      <div className="bg-[#fff6ee] text-black container  px-2">




        {/* Artbook Section */}
        <section className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl font-bold mb-4 uppercase">Nagitimu Sri Lanka - Artbook</h1>
          <p className="mb-6">
            Nagitimu Sri Lanka was born with the goal of encouraging social distancing during the lockdown of
            2020.<br />
            It included children showcasing their talents in art and music. <br />
            The Nagitimu Sri Lanka Art Book was compiled with entries received from local and global
            contestants, <br />
            portraying their vision for a better tomorrow.To mark Children's day in 2020,<br />
            Gammadda dedicated this piece of art; the Nagitimu Sri Lanka Art Book, to
            children in Sri Lanka and overseas. <br />Nagitimu Sri Lanka highlights the importance of child rights.
            Children
            are the future of the world and they deserve to be treated equally.<br /> They have the right to life
            and to live
            it to the fullest.
          </p>
          <ul className="nav-item" style={{ marginTop: '20px', marginBottom: '20px' }}>
            <Link target={"_blank"}
              to="https://cdn.newsfirst.lk/gammadda/1QVOxAGlvRbUdbmINcOhBdLXvKU41-6EY/view?usp=sharing"
              className="button">Open Book</Link>
          </ul>
        </section>

        {/* About Nagitimu Sri Lanka */}
        <section className="max-w-4xl mx-auto text-center mt-12">
          <h1 className="text-3xl font-bold mb-4 uppercase">Nagitimu Sri Lanka</h1>
          <p>
            Several nations, including Sri Lanka, have been hailed for curbing the spread of the pandemic that
            forced the
            entire planet into a lockdown. <br />There was a small glimmer of hope amidst all the chaos. That hope
            that endured
            on the tip of the tongue of every Sri Lankan was “Nagitimu Sri Lanka”. As soon as the rolling curfews
            took
            effect and were threatening to morph into a full blown lockdown- Gammadda introduced an art
            competition to
            keep families with young children and young people occupied during the lockdown as part of a campaign
            to
            promote social distancing.
          </p>
          <p className="mt-4">
            Nagitimu Sri Lanka empowered every single Sri Lankan citizen regardless of race, religion, caste or
            creed to
            give voice to the rebuilding of our country. ‘Nagitimu Sri Lanka' captured a wave of hope amongst
            young Sri
            Lankans. A new wave. One of silent determination and perhaps most importantly, unity.
          </p>
        </section>


        <h2 className="gm---heading-2">Campaigns of Nagitimu Sri Lanka</h2>
        <div id="artcompetition" className="section ">
          <div className="container">
            <div className="row door-to-door">
              <div id="w-node-_5c0f80de-c708-2e4c-265e-9155880fd35c-82f57a24" className="col-md-6 col-12 order-md-first order-last content-wrapper-universe">
                <h3 className="h3-universe">Art Competition</h3>
                <p className="p-left universe">Nagitimu Sri Lanka was launched with an art competition that
                  invited submissions from all Sri Lankans.
                  The theme was “Future Sri Lanka” and people were asked to conceptualize their vision for
                  Future Sri Lanka through art.
                  They were free to use any medium- color pencils, crayons. water colors, oil paints,
                  charcoal, pencils or pens etc.
                  Submissions were rendered on media ranging from canvas to paper to sheets torn from school
                  copy books.
                  Nagitimu Sri Lanka celebrated art from across Sri Lanka and the world. </p>
                <a href="research-and-data.html" className="button universe">Learn more</a>
              </div>
              <div className="col-md-6 col-12 order-md-last order-first">
                <img class="img" src={Art_Competition_img} alt="" />

              </div>
            </div>
          </div>
        </div>


        <div id="janatha" className="section">
          <div className="container  mb-3">
            <div className="row janatham">
              <div className="aspect-w-16 aspect-h-9 mb-10 col-md-6 col-12">
                <iframe
                  className="nagitimu-custome-iframe"
                  src="https://www.youtube.com/embed/39SOhrCM9uM?rel=0&controls=1&autoplay=0&mute=0&start=0"
                  title="Gammadda Thakshalawa"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="content-wrapper-universe col-md-6 col-12">
                <h3 className="h3-universe">Nagitimu Sri Lanka Song</h3>
                <p className="p-left universe">‘Nagitimu Sri Lanka’, or ‘Rise up Sri Lanka!’, was sung by some
                  of
                  Lanka’s best-known singers and people. An anthem for hope amidst the uncertainty.
                  A prayer for better days ahead. The trilingual song was sung by Sinhalese, Tamils,
                  Muslims, Burghers, Malays, expatriates and foreigners who all love Sri Lanka. People sang.
                  People danced. People signed (using sign language).</p>
              </div>
            </div>
          </div>

          {/*Voices of Nagitimu*/}
          <div className="conatiner mb-3">
            <div className="row nagitimu">
              <div id="w-node-_3343ff0e-6654-1b36-fa0e-fa944cdb95ac-82f57a26" className="col-md-6 col-12 content-wrapper-universe order-md-first order-last">
                <h3 className="h3-universe">Voices of Nagitimu Sri Lanka</h3><p
                  className="p-left universe">Following the success of the Nagitimu Sri Lanka song- people were
                  motivated to contribute towards the efforts to rebuilding the economy. People were asked to shares
                  their ideas and vision for future Sri Lanka using a short video format in an effort to democratize
                  the rebuilding of the Sri Lankan economy. Hyde Park, London is known for its Sunday soapbox
                  orators, who have assembled at Speakers' Corner since 1872 to discuss religion, politics, and
                  other topics. In 2020 Sri Lanka, WhatsApp was the proverbial soapbox.</p>
              </div>

              <div className="col-md-6 col-12 order-md-last order-firt">
                <img style={{width:'100%'}}
                  src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57ae2_Rectangle%2075.png"
                  id="w-node-_3343ff0e-6654-1b36-fa0e-fa944cdb95b6-82f57a26" alt="" />
              </div>


            </div>
          </div>



          {/*innovation*/}
          <div className="container mb-3">
            <div className="row nagitimu">
              <div className="aspect-w-16 aspect-h-9 mb-10 col-md-6 col-12">
                <iframe
                  className="nagitimu-custome-iframe"
                  src="https://www.youtube.com/embed/EfMOkFCaSsA?rel=0&controls=1&autoplay=0&mute=0&start=0"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="සිතා ඉදිරිය ගැන, තනමු නව නිපැයුම්"
                ></iframe>
              </div>

              <div id="w-node-_954167f4-728b-c6c6-40e2-dd09ad19be81-82f57a26" className="content-wrapper-universe col-md-6 col-12">
                <h3 className="h3-universe">Innovation Nation</h3><p className="p-left universe">Gammadda in
                  partnership with V- Force launched Innovation Nation to tap in to Sri Lankan ingenuity and the
                  innovative ideas of people on solving current and future problems that are not yet addressed using
                  existing means. Innovation is the life blood of Nagitimu Sri Lanka- as innovative thinking and
                  creative solutions to navigate the post-COVID world is the need of the hour. Innovation Nation
                  aims to support inventors to obtain their patents, and introduce them to investors and the general
                  public.</p></div>

            </div>
          </div>




          {/*  CREATIVE VESAK  */}
          <div className="container">
            <div className="row">
              <div id="w-node-_9ccb9e3c-ef54-e1cd-7a39-1cc2f4c29ea4-82f57a26" className="content-wrapper-universe col-md-6 col-12 order-md-first order-last">
                <h3 className="h3-universe">Creative Vesak</h3><p className="p-left universe">In an effort to
                  encourage all Sri Lankans to celebrate Wesak responsibly with social distancing measures in place-
                  Nagitimu Sri Lanka launched a mini campaign to showcase innovative Wesak Lanterns or Koodus.
                  Buddhists, Hindus, Muslims and Christians embraced this celebration by sending their own
                  creations.</p>
              </div>

              <div className="col-md-6 col-12 order-md-last order-first">
                <img style={{width:'100%'}}
                  src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57ade_Rectangle%2077%20(1).png"
                  id="w-node-_9ccb9e3c-ef54-e1cd-7a39-1cc2f4c29eab-82f57a26" alt="" />
              </div>
            </div>

          </div>
        </div>



      </div>
    </div>);
};

export default GammaddaNagitimuSriLanka;
